import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IProgressValueProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    withProgressContext
} from "../../context";
import Text from "../../../text";

const ProgressValueContent: FC<ProgressPartContentProps<IProgressValueProps>> = ({
    customTheme: customThemeProp,
    icon: IconComponentProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const content = children ?? (context.isValueVisible ? context.valueText : undefined);

    if(!content && !IconComponentProp) {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        {
            IconComponentProp ?
                <IconComponentProp
                    customColor={context.currentColors.valueColor}
                    size={context.currentSize.iconSize}
                    color="mid"
                />
            :
                null
        }
        {
            content ?
                <Text
                    customColor={context.currentColors.valueColor}
                    variant={context.currentSize.labelVariant}
                    customTheme={customTheme}
                    style={stylesheet.value}
                    numberOfLines={1}
                >
                    {content}
                </Text>
            :
                null
        }
    </View>;
};
export default withProgressContext("Value", ProgressValueContent);
